import { useSelector } from "react-redux";

export default function usePlayerDetails() {
  const playerDetails = useSelector((state) => state.lobby.player);

  if (!playerDetails) {
    console.warn("Missing data at userDetails");
    return {};
  }

  return { ...playerDetails, pseudo: playerDetails.playerStatus === 'plocked' };
}
